import { post } from './api';
// import{
//   mockdataSuccessRespond,
//   mockdataFailRespond
// }from '../mock-data/getInTouch.mock';

const endpoints = {
  getInTouchUrl: `${window.envConfig.SELLERS_API_BASE_URL}Users/getintouch`,
};

export const issueTypes = [
  {
    label: 'Incorrect payment',
    value: 1,
  },
  {
    label: 'Incorrect item details',
    value: 2,
  },
  {
    label: 'General enquiry',
    value: 3,
  },
  {
    label: 'Other',
    value: 4,
  },
];

type ReturnError = {
  errorMessage: string;
  errorCode: string | number | null;
  moreInfo: string | null;
  redirectUrl: string | null;
  validationMessages: string | null;
};

export type GetInTouchReturn = {
  message: string;
  error: ReturnError | null;
  hasError: boolean;
};

export type GetInTouchRequest = {
  lotSku: string | number;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  issueType: number;
  message: string;
};

export const submitGetInTouch = async (
  request: GetInTouchRequest,
  token: string
): Promise<GetInTouchReturn> => {
  const results = await post<GetInTouchReturn>({
    url: endpoints.getInTouchUrl,
    body: request as any,
    token,
  });
  // return mockdataSuccessRespond;
  return results;
};
